function numberToEuro(number){
  const euroValue = (parseInt(number) / 100).toFixed(2).replace(".", ",") + "€";
  return euroValue;
}

// VARIANTS GESTION

const productVariantsDatabase = document.querySelector('.product .product-variants-database');
const productVariantsDatabaseItems = productVariantsDatabase.querySelectorAll('input');

function updateSelectedVariants() {

  const productsVariantsContainer = document.querySelector('.product variant-radios');
  const productVariantsOptions = productsVariantsContainer.querySelectorAll('.product-form__input');
  const productVariantsOptionsInput = productsVariantsContainer.querySelectorAll('input');

  if(productVariantsOptions.length == 1) {

    const productFirstOption = productVariantsOptions[0];
    const productFirstOptionValues = productFirstOption.querySelectorAll('label');

    // GET SELECTED VARIANTS

    let selectedVariants = [];
    let productFirstOptionSelectedValue;

    productVariantsOptionsInput.forEach(input => {
      if(input.checked == true) {
        selectedVariants.push(input.value);
      }
    })

    // GET INPUT DATABASE OF SELECTED VARIANTS

    let selectedInput = Array.from(productVariantsDatabaseItems).find((input) => {
      let inputTitle = input.getAttribute("data-title");
      return selectedVariants.every((valeur) => inputTitle.includes(valeur));
    });

    productFirstOptionValues.forEach(label => {

      let values = [label.dataset.optionValue]

      let databaseInput = Array.from(productVariantsDatabaseItems).find((input) => {
        let inputTitle = input.getAttribute("data-title");
        return values.every((valeur) => inputTitle.includes(valeur));
      });

      // SET DATAS

      const valuePrice = databaseInput.dataset.price;
      const valueComparAtPrice = databaseInput.dataset.compareAtPrice;

      const regularPriceContainer = label.querySelector('.option-price .regular-price');
      regularPriceContainer.innerHTML = `${numberToEuro(valuePrice)}`;

      const compareAtPriceContainer = label.querySelector('.option-price .compare-at-price');
      const economyContainer = label.querySelectorAll('.price-economy');
      const disountPriceContainer = label.querySelector('.price-discount');

      if(databaseInput.dataset.compareAtPrice){

        // COMPARE AT PRICE

        compareAtPriceContainer.innerHTML = `${numberToEuro(databaseInput.dataset.compareAtPrice)}`;

        // DISCOUNT PRICE

        const disountPrice = Math.round(((valueComparAtPrice - valuePrice) / valueComparAtPrice) * 100)|| 0;
        disountPriceContainer.innerHTML = `-${disountPrice}%`;

        // ECONOMY PRICE

        const economyPrice = valueComparAtPrice - valuePrice;
        economyContainer.forEach(item => {
          item.innerHTML = `Vous économisez ${numberToEuro(economyPrice)}`;
        })

      }else {
        compareAtPriceContainer.innerHTML = '';
        disountPriceContainer.innerHTML = '';
        economyContainer.forEach(item => {
          item.innerHTML = '';
        })
      }

    })

  }else if(productVariantsOptions.length == 2) {

    const productFirstOption = productVariantsOptions[0];
    const productFirstOptionValues = productFirstOption.querySelectorAll('input');
    let productFirstOptionSelectedValue;

    productFirstOptionValues.forEach(input => {
      if(input.checked == true){
        productFirstOptionSelectedValue = input;
      }
    })

    const productSecondOption = productVariantsOptions[1];
    const productSecondOptionValues = productSecondOption.querySelectorAll('label');

    // UPDATE SECOND OPTION VALUES

    productSecondOptionValues.forEach(label => {

      let values = [productFirstOptionSelectedValue.value, label.dataset.optionValue]

      let databaseInput = Array.from(productVariantsDatabaseItems).find((input) => {
        let inputTitle = input.getAttribute("data-title");
        return values.every((valeur) => inputTitle.includes(valeur));
      });

      // SET DATAS

      const valuePrice = databaseInput.dataset.price;
      const valueComparAtPrice = databaseInput.dataset.compareAtPrice;

      const regularPriceContainer = label.querySelector('.option-price .regular-price');
      regularPriceContainer.innerHTML = `${numberToEuro(valuePrice)}`;

      const compareAtPriceContainer = label.querySelector('.option-price .compare-at-price');
      const economyContainer = label.querySelectorAll('.price-economy');
      const disountPriceContainer = label.querySelector('.price-discount');

      if(databaseInput.dataset.compareAtPrice){

        // COMPARE AT PRICE

        compareAtPriceContainer.innerHTML = `${numberToEuro(databaseInput.dataset.compareAtPrice)}`;

        // DISCOUNT PRICE

        const disountPrice = Math.round(((valueComparAtPrice - valuePrice) / valueComparAtPrice) * 100)|| 0;
        disountPriceContainer.innerHTML = `-${disountPrice}%`;

        // ECONOMY PRICE

        const economyPrice = valueComparAtPrice - valuePrice;
        economyContainer.forEach(item => {
          item.innerHTML = `Vous économisez ${numberToEuro(economyPrice)}`;
        })

      }else {
        compareAtPriceContainer.innerHTML = '';
        disountPriceContainer.innerHTML = '';
        economyContainer.forEach(item => {
          item.innerHTML = '';
        })
      }

    })

  }else {
    console.log("ERROR");
  }

}
updateSelectedVariants();

/* UPDATE MAIN BUTTON PRICE */

function updateMainButtonPrice(selectedLabel) {

  function updatePrice(newPrice) {
    
    const productMainButton = document.querySelector('.product .product-form__submit');
      
      if (productMainButton) {
  
          let priceContainer = productMainButton.querySelector('.final-price');
      
          if (priceContainer) {
              priceContainer.textContent = `${newPrice}`;
          } else {
              priceContainer = document.createElement("span");
              priceContainer.classList.add('final-price');
              priceContainer.textContent = `${newPrice}`;
              productMainButton.appendChild(priceContainer);
          }
      }
    
  }

  const slsPurchaseOptionsContainer = document.querySelector('.product .sls-purchase-options-container');

  if(slsPurchaseOptionsContainer == null){
   
    const productOptions = document.querySelectorAll('.product .product-form__input');
    const lastOption = productOptions[productOptions.length-1];
    const selectedOptionValues = lastOption.querySelectorAll('input');
  
    selectedOptionValues.forEach(input => {
      
      if(input.checked == true){
  
        const inputLabel = document.querySelector(`label[for="${input.id}"]`);
        const price = inputLabel.querySelector('.option-price .regular-price').textContent;
        updatePrice(price);
        
      }
    })

  }else {
  
    const selectedSubscriptionOptionPrice = document.querySelector('.sls-active .money');
    price = selectedSubscriptionOptionPrice.textContent;
    updatePrice(price);

  }
  
}

setTimeout(() => {
  updateMainButtonPrice();
}, 300);

/* PRODUCT VARIANS ADVANCED */

const productVariantAdvanced = document.querySelector('.product-variant-advanced');

function updateVariantDuration() {

  let customOptionQuantity;
  
  if(productVariantAdvanced){
    const customOptionSelected = productVariantAdvanced.querySelector('.option__item.selected');
    customOptionQuantity = customOptionSelected.dataset.quantity
  }else{
    customOptionQuantity = 1;
  }

  const quantityOption = document.querySelector('.product .product-form__input[data-option="Quantité"]');
  const quantityOptionInput = quantityOption.querySelectorAll('input');

  // UPDATE QUANTITY ALL OPTIONS
  
  let dailyCostStatus = true;

  let newDurationDays;
  let newDurationMonths;
  let weight;
  let finalDailyCost;
  let measureUnit;
  
  quantityOptionInput.forEach(option => {

    // SET INFORMATIONS
    
    if(option.checked == true) {

      if(option.dataset.optionMeasureUnit != ""){
          measureUnit = option.dataset.optionMeasureUnit;
      }

      if(option.dataset.optionDurationDays != ""){
          newDurationDays = option.dataset.optionDurationDays/customOptionQuantity;
      }

      if(option.dataset.optionWeight != ""){
          weight = option.dataset.optionWeight;
      }

      if(option.dataset.optionPrice != ""){
          finalDailyCost = option.dataset.optionPrice/newDurationDays;
      }
      
    }

    // CHECK META
    
    if(option.dataset.optionMeasureUnit == ""){
        dailyCostStatus = false;
    }

    if(option.dataset.optionDurationDays == ""){
        dailyCostStatus = false;
    }

    if(option.dataset.optionWeight == ""){
        dailyCostStatus = false;
    }

    if(option.dataset.optionPrice == ""){
        dailyCostStatus = false;
    }
    
    // SET PRODUCTS DURATION
    
    const inputLabel = quantityOption.querySelector(`label[for="${option.id}"]`);    
    const durationContainer = inputLabel.querySelector('.option-name .option-duration');

    if(option.dataset.optionDurationMonth != ""){
      newDurationMonths = Math.round(option.dataset.optionDurationMonth/customOptionQuantity*100)/100;
      durationContainer.innerHTML = `/ ${newDurationMonths} mois`;
    }

  })
  
  const dailyCost = document.querySelector('.product .daily-cost');
  console.log(dailyCostStatus);

  if(dailyCostStatus == true){
    dailyCost.classList.add('active')
  }else if(dailyCostStatus == false){
    dailyCost.classList.remove('active');
  }

  // UPDATE DAILY COST

  const dailyCostDaysContainer = dailyCost.querySelector('.days');
  const dailyCostWeightContainer = dailyCost.querySelector('.weight');
  const dailyCostPriceContainer = dailyCost.querySelector('.price');

  dailyCostDaysContainer.innerHTML = `${newDurationDays}`;
  dailyCostWeightContainer.innerHTML = `${weight}${measureUnit}`;
  dailyCostPriceContainer.innerHTML = `${numberToEuro(finalDailyCost)}`;

}
updateVariantDuration();

function updateOptionsTags(option) {

  const recommendedDuration = option.dataset.quantity*2;
  const optimumDuration = option.dataset.quantity*4;

  const productOptionQuantityLabel = document.querySelectorAll('.product-form__input[data-option="Quantité"] label');

  productOptionQuantityLabel.forEach(label => {

    const tagContainer = label.querySelector('.tag');
    
    if(label.dataset.durationMonth == recommendedDuration){
      tagContainer.innerHTML = `Recommandé`;
      label.classList.add('with-tag');
    }else if(label.dataset.durationMonth == optimumDuration){
      tagContainer.innerHTML = `Cure optimale`;
      label.classList.add('with-tag');
    }else {
      tagContainer.innerHTML = ``;
      label.classList.remove('with-tag');
    }
    
  })
  
}

if(productVariantAdvanced){ 
  
  const productVariantAdvancedVariants = productVariantAdvanced.querySelectorAll('.variant__item');
  
  productVariantAdvancedVariants.forEach(variant => {
  
    const variantOptions = variant.querySelectorAll('.option__item');
    
    const firstAdvancedVariantOption = variantOptions[0];

    updateOptionsTags(firstAdvancedVariantOption);
  
    variantOptions.forEach(option => {
  
      option.addEventListener('click', () => {
  
        // SET DESIGN
  
        for(let i=0;i<variantOptions.length;i++){
            variantOptions[i].classList.remove('selected');
        }
        option.classList.add('selected');
  
        // ACTIONS
  
        updateVariantDuration();

        // UPDATE OPTIONS TAGS
        
        updateOptionsTags(option);
  
      })
    })
  
  })

}

// VARIANTS OPTIONS ACTIONS

const productOptionsLabel = document.querySelectorAll('.product .product-form__input label');

productOptionsLabel.forEach(label => {
  
  label.addEventListener('click', () => {
    
    setTimeout(() => {
      updateSelectedVariants();
      updateVariantDuration();
    }, 100);
    
    setTimeout(() => {
      updateMainButtonPrice();
    }, 300);
    
  })
})

// SUBSCRIPTION OPTIONS ACTIONS

setTimeout(() => {
  
  const slsPurchaseContainer = document.querySelector('.product .sls-purchase-options-container');
  
  if(slsPurchaseContainer != null) {
    
    const slsOptions = slsPurchaseContainer.querySelectorAll('.sls-option-container');
  
    slsOptions.forEach(option => {
      option.addEventListener('click', () => {
        setTimeout(() => {
          updateMainButtonPrice();
        }, 300);
      })
    })

  }
  
}, 300);

// STICKY ATC - SCROLL APPARITION

const mainProductButtonAtc = document.querySelector('.product');
const productStickyAtc = document.querySelector('.product-sticky-atc');

const stickyObserver = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
        if (entry.isIntersecting) {
            productStickyAtc.removeAttribute('open');
        } else {
            productStickyAtc.setAttribute('open', '');
        }
    });
}, {
    threshold: 0
});

stickyObserver.observe(mainProductButtonAtc);